import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import SyncIcon from "@material-ui/icons/Sync";

import {
  IconButton,
  Typography
} from "@material-ui/core";
import DialogSyncResult from "./DialogSyncResult";

const useStyles = makeStyles((theme) => ({
 
}));
 


export default function ButtonSync({project,label=''  }) {
  const classes = useStyles(); 
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const handleOnOpen = () => {
    setIsDialogOpen(true);
  };
  const handleOnClose = () => {
    setIsDialogOpen(false);
  }; 
  
  return (
    <> 
      {project&&project.user_type_id>0&&(     
        <>
        {label!=''&&<Typography variant="body2" style={{ marginRight: '8px' }} onClick={handleOnOpen}>{label}</Typography>}
        <IconButton onClick={handleOnOpen} color="primary" title="Sync Project">
            <SyncIcon/>
        </IconButton> 
        </>
      )}
      {project&&project.user_type_id>0&&(     
            
        <DialogSyncResult
          //fullScreen
          open={isDialogOpen}
          onClose={handleOnClose}       
          project_id={project.id}
        
        />
      )}  
    </>
  );
}
